import React from 'react';

import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { ImageWrapper } from './incentive-card.styled';

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;

  padding: 1rem;
  border-block-end: 1px solid ${Styles.color.grey.four};
`;

export const ImageWrapperSkeleton = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 8px;
  flex: 1;
  margin-inline-end: 0.5rem;
`;

export const TextWrapperSkeleton = styled.div`
  height: 100%;
  width: 100%;

  & > span > span {
    border-radius: 1rem;
  }

  display: flex;
  flex-direction: column;
`;

export const SkeletonImageWrapper = styled(ImageWrapper)`
  width: 100%;
  padding: 0;
`;

export const IncentiveCardSkeleton: React.FC = () => {
  return (
    <ContentRow>
      <ImageWrapperSkeleton>
        <Skeleton height={'6.5rem'} width={'9.5rem'} />
      </ImageWrapperSkeleton>
      <TextWrapperSkeleton>
        <Skeleton width={'70%'} height={'1.5rem'} />
        <Skeleton width={'90%'} height={'1.25rem'} />
        <Skeleton width={'45%'} height={'1.75rem'} />
      </TextWrapperSkeleton>
    </ContentRow>
  );
};
